import React from "react";

// Icons
import horizontalArrow from "../../../../assets/icons/horizontal_arrow.svg";
import tealTemplateIcon from "../../../../assets/icons/templates_icons/cyan-note-text.svg";
import primaryTemplateIcon from "../../../../assets/icons/templates_icons/indigo-note-text.svg";
import greenTemplateIcon from "../../../../assets/icons/templates_icons/lime-note-text.svg";
import orangeTemplateIcon from "../../../../assets/icons/templates_icons/orange-note-text.svg";
import yellowTemplateIcon from "../../../../assets/icons/templates_icons/yellow-note-text.svg";

// External Components
import Spinner from "react-bootstrap/Spinner";

// Stylesheets
import "./TemplatesTab.scss";
import { sort } from "fast-sort";

// Constant
export const colorIcons = {
  green: greenTemplateIcon,
  orange: orangeTemplateIcon,
  primary: primaryTemplateIcon,
  teal: tealTemplateIcon,
  yellow: yellowTemplateIcon,
};

function TemplatesTab({
  isLoading = false,
  templates = [],
  handleTemplateEdit = () => console.log("handleTemplateEdit is not provided"),
}) {
  return (
    <div className="templates-tab-container px-8">
      {!isLoading &&
        sort(templates)
          .asc((template) => template?.templateTitle?.toLowerCase())
          .map((template) => (
            <TemplatesCard
              key={template.templateId}
              template={template}
              handleTemplateEdit={handleTemplateEdit}
            />
          ))}

      {!isLoading && templates.length === 0 && (
        <div className="templates-card-container-loader">
          <span className="lead"> {"Create your first template!"}</span>
        </div>
      )}
      {isLoading && (
        <div className="templates-card-container-loader">
          <Spinner animation="border" role="status" />{" "}
        </div>
      )}
    </div>
  );
}

function TemplatesCard({ template, handleTemplateEdit }) {
  const fileIcon = colorIcons[template.colorCode.label.toLowerCase()];

  return (
    <div
      className="templates-card-container"
      onClick={() => handleTemplateEdit(template)}
    >
      <div>
        <img
          src={fileIcon}
          alt="template-icon"
          width={"24px"}
          height={"24px"}
        />
      </div>
      <div>
        <div>{template.templateTitle}</div>
        <div>{`${template.requiredDocuments.length} Documents`}</div>
      </div>
      <div>
        <img
          src={horizontalArrow}
          alt="arrow-icon"
          width={"16px"}
          height={"16px"}
        />
      </div>
    </div>
  );
}

export default TemplatesTab;
